// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientMedicationList = createAction(
  'SET_PATIENT_MEDICATION_LIST'
)
export const setPatientDashboardMedicationList = createAction(
  'SET_PATIENT_DASHBOARD_MEDICATION_LIST'
)
export const setPatientMedicationValue = createAction(
  'SET_PATIENT_MEDICATION_VALUE'
)
export const setMedicationReferer = createAction('SET_MEDICATION_REFERER')
export const setMedicationActiveTab = createAction('SET_MEDICATION_ACTIVE_TAB')
export const setCarePlanActiveTab = createAction('SET_CAREPLAN_ACTIVE_TAB')

export const setIntakeList = createAction('SET_INTAKE_LIST')
export const setIntakeValue = createAction('SET_INTAKE_VALUE')

export const setMedicationList = createAction('SET_MEDICATION_LIST')
export const setAssignedMedicationList = createAction(
  'SET_ASSIGNED_MEDICATION_LIST'
)
export const setMedicationRuleList = createAction('SET_MEDICATION_RULE_LIST')
export const setOrderingList = createAction('SET_ORDERING_LIST')
export const setPharmacyList = createAction('SET_PHARMACY_LIST')

export const setSearchLoading = createAction('SET_SEARCH_LOADING')

export const setMedicationPredefinedFilter = createAction(
  'SET_MEDICATION_PREDEFINED_FILTER'
)

export const resetMedication = createAction('RESET_MEDICATION')
export const setDosageTypes = createAction('SET_DOSAGE_TYPES')
